import FormSection from 'components/CreationForms/base/FormSection';
import CustomFields from 'components/CreationForms/fields/CustomFields';
import { ExternalProperty } from 'crono-fe-common/types/externalProperty';

interface OtherFieldsSectionProps {
  properties: ExternalProperty[];
  values: Record<number, string>;
  onChange: (propertyId: number, value: string) => void;
}

/** "Other fields" block of the creation forms: the custom fields that aren't tags. */
const OtherFieldsSection = ({
  properties,
  values,
  onChange,
}: OtherFieldsSectionProps) => {
  if (properties.length === 0) return null;

  return (
    <FormSection title="Other fields">
      <CustomFields
        properties={properties}
        values={values}
        onChange={onChange}
      />
    </FormSection>
  );
};

export default OtherFieldsSection;
